module.exports = "/static/assets/0d2342a6ac4a24d3b4aedd0e42ffad5f.png";